(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asim-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.asim .menu').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.getElementById('mobile-menu');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  });
  document.querySelectorAll('.asim .mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = document.getElementById('mobile-menu');
      const button = document.querySelector('.asim .menu');
      menu.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-ball-in-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fbi-product').forEach((root) => {
    root.querySelectorAll('.thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const image = root.querySelector('[data-main-media] .main-image');
        if (image) {
          image.src = thumb.dataset.imageSrc;
          image.removeAttribute('srcset');
        }
        root.querySelectorAll('.thumb').forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    const quantity = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; });
    root.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const price = root.querySelector('[data-product-price]');
      const compare = root.querySelector('[data-compare-price]');
      const button = root.querySelector('[data-add-button]');
      price.textContent = option.dataset.price;
      if (option.dataset.compare && option.dataset.compare !== option.dataset.price) { compare.textContent = option.dataset.compare; compare.hidden = false; } else { compare.hidden = true; }
      button.disabled = !available;
      root.querySelector('[data-add-label]').textContent = available ? 'Add to cart' : 'Sold out';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
